module.exports = __webpack_public_path__ + "img/stage-monitor2.fccb32dc.png";